<template>
  <!-- 演练记录 -->
  <div class="page_box">
      <div class="page_option_box">
      <el-page-header
        @back="$Common.pageJump('/emergency_plan', 3)"
        content="演练记录"
      >
      </el-page-header>
      </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="openTime" label="开始时间" align="center">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.openTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="durationTime" label="演练时长" align="center">
          </el-table-column>
          <el-table-column prop="openerName" label="预案启动者" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="rowData">
              <el-link
                type="primary"
                @click="delData(rowData.row.id)"
                :underline="false"
                >删除</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="getDataDetails(rowData.row.id)"
                :underline="false"
                >演练详情</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>

      <el-dialog
        title="演练详情"
        :visible.sync="dialogTableVisible"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="40%"
      >
        <div class="block" style="padding:20px">
          <div class="drill_detalis_top">
            <div>
              演练开始时间：{{
                $Common.dateFormatDateTwo(drillDetailsData.openTime)
              }}
            </div>
            <div>演练进行时长：{{ drillDetailsData.durationTime }}秒</div>
            <div>演练启动人：{{ drillDetailsData.openerName }}</div>
          </div>
          <el-timeline>
            <el-timeline-item
              icon="el-icon-locatio"
              type="primary"
              v-for="(value,
              key) in drillDetailsData.safeDrillPlanRecordContents"
              :key="key"
            >
              <div>
                操作时间：{{ $Common.dateFormatDateTwo(value.addTime) }}
              </div>
              <div>操作内容：{{ value.operate }}</div>
              <div>
                演练类型：{{
                  $store.state.select.drillContentType[value.type].nameOne
                }}
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EmergencyPlanMenu from "@/components/EmergencyPlanMenu";

export default {
  name: "",
  components: { EmergencyPlanMenu },
  props: {},
  data() {
    return {
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      // 请求数据
      requestParams: {
        drillPlanId: sessionStorage.getItem("planDetailsId"),
        pageNum: 1,
        pageSize: 20
      },
      dialogTableVisible: false,
      drillDetailsData: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 获取数据
    async getDataList() {
      var newParamData = {
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize,
        drillPlanId: this.requestParams.drillPlanId
      };

      let res = await this.$Http.getDrillRecord(newParamData);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取详情
    async getDataDetails(id) {
      var newParamData = {
        recordId: id
      };
      let res = await this.$Http.delDrillDetails(newParamData);
      // console.log(res)
      if (res.code == 200) {
        if (res.data) {
          this.drillDetailsData = res.data;
          this.dialogTableVisible = true;
        } else {
          this.$message("暂无演练记录详情！");
        }
      } else if (res.code == 101) {
        this.$message("暂无演练记录详情！");
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleCurrentChange(val) {
      this.requestParams.pageNum = val;
      this.getDataList();
      console.log(`当前页: ${val}`);
    },

    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            id: dataId
          };
          let res = await this.$Http.delDrillRecord(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    }
  },
  created() {
    this.getDataList();
  },
  mounted() {}
};
</script>
<style scoped></style>
